export default __webpack_public_path__ + "static/media/city.36fbbe0b.png";